import { F } from '@/utils/intl';
import { Button, Popconfirm, Tooltip } from 'antd';
import React from 'react';
import { declineServiceRequestRequest } from '@/services/api/serviceRequest';
import { CloseCircleOutlined } from '@ant-design/icons';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { processSingleServiceRequest } from '@/components/Kanban/ServiceRequests/Calendar/utils';

const DeclineServiceRequestAction = ({
                                       children = null,
                                       serviceRequest,
                                       setLoading = (loading: boolean) => {
                                       },
                                       onSuccess = () => {
                                       },
                                       open,
                                       onOpenChange = () => {},
                                       buttonSize = 'small',
                                       showActionText = false,
                                       ...buttonProps
                                     }) => {
  const handleDecline = () => {
    if (setLoading)
      setLoading(true)
    return declineServiceRequestRequest({
      params: {
        serviceRequestId: serviceRequest.id
      }
    }).then(onSuccess)
  }

  if (!processSingleServiceRequest(serviceRequest).isDeclinable) return null

  return <CheckAccess access={[PERMISSIONS.ServiceRequests.CANCEL, PERMISSIONS.BUSINESS_PARTNER]}>
    <Popconfirm
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={handleDecline}
      title={<F id={'pages.serviceRequests.declineAppointmentConfirm'}
                defaultMessage={'Are you sure to decline this appointment?'}/>}>

      <Tooltip title={showActionText ? undefined : <F id={'common.actions.decline'} defaultMessage={'Decline'}/>}>
        <Button size={buttonSize} shape={"round"} color={"danger"} variant={"filled"} icon={<CloseCircleOutlined/>} {...buttonProps}>
          {showActionText && <F id={'common.actions.decline'} defaultMessage={'Decline'}/>}
        </Button>
      </Tooltip>

    </Popconfirm>
  </CheckAccess>
}

export default DeclineServiceRequestAction
